var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "hammer",
          rawName: "v-hammer:swipe",
          value: _vm.onSwipe,
          expression: "onSwipe",
          arg: "swipe"
        }
      ],
      staticClass: "product-gallery"
    },
    [
      _c(
        "div",
        { staticClass: "grid-wrap" },
        [
          _c(
            "div",
            { staticClass: "stage", on: { click: _vm.openGallery } },
            [
              _c(
                "transition",
                { attrs: { name: "fade" } },
                [
                  _c("super-image", {
                    key: _vm.activeSrc,
                    attrs: {
                      src: _vm.activeSrc,
                      color: "#f1f1f1",
                      "fill-space": ""
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.limitedImages, function(src, i) {
            return _c(
              "button",
              {
                staticClass: "thumb reset",
                on: {
                  click: function($event) {
                    _vm.activeIdx = i
                  }
                }
              },
              [
                _c("super-image", {
                  attrs: { src: src, color: "#f1f1f1", "fill-space": "" }
                })
              ],
              1
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _vm.limitedImages.length > 1
        ? _c(
            "div",
            { staticClass: "pagination" },
            _vm._l(_vm.limitedImages, function(src, i) {
              return _c("span", {
                class: ["dot", { active: i === _vm.activeIdx }]
              })
            }),
            0
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }